
(function($) {

    // shorten references to variables. this is better for uglification var kendo = window.kendo,
    var ui = kendo.ui,
        Widget = ui.Widget;


    var KontoMenu = Widget.extend({
        init: function(element, options) {
        	var that = this;

        	if (!options.type)
        		options.type = "side";

        	// base call to widget initialization
        	Widget.fn.init.call(this, element, options);

        	$(document).on("pageLoaded", that._pageLoaded.bind(that));

        	that._toggleButton = $(".navbar-header .navbar-toggle");

            that.element.html("");
            if (options.type == "navbar") {
            	var els = that._createElementsNavbar(options.dataSource);
            	that.element.append(els);
            }
            else {
	            var els = that._createElements(options.dataSource);
	            var wrapper = that._createWrapper(els);
	            that.element.append(wrapper);
	            var selectedElement = that.selectPutanja(window.location.href);
				if(selectedElement == null){
					var trenutna = $.cookie(that._getTrenutnaCookieName(window.location.href));
					if(trenutna != undefined){
						selectedElement = that.selectPutanja(trenutna);
					}
				}

	            that._sidebar = that.element.find(".sidebar-nav");
	            that._menu = that.element.find("ul:first");
	            that._metisMenu = that._menu.metisMenu({
	                toggle: false
	            }).data("plugin_metisMenu");
            }
        },
        options: {
             // the name is what it will appear as off the kendo namespace(i.e. kendo.ui.MyWidget).
             // The jQuery plugin would be jQuery.fn.kendoMyWidget.
             name: "KontoMenu",
             koristiIkone: false
        },
        _pageLoaded: function (event, data) {
            if (this.options.type === "side"){
				var selectedElement =  this.selectPutanja(data.url);
				if(selectedElement == null){
					var trenutna = $.cookie(this._getTrenutnaCookieName(window.location.href));
					if(trenutna != undefined){
						selectedElement = this.selectPutanja(trenutna);
					}
				}				
			}               
        },
        _createWrapper: function (els) {
	    	var sidebar = $("<div></div>");
	    	sidebar.append(els);
			sidebar
			  .addClass("navbar-collapse")
			  .attr("id", "navMain");
			  //.addClass("navMain");
			  //.addClass("justify-content-end");
	    	return sidebar;
	    },
	    _createElements: function (items, level) {
	    	var that = this;

	    	if (!level)
	    		level = 1;
			var list = $("<ul></ul>");
			list.addClass("nav");
	    	if (level == 1) {
	    		list.attr("id", "side-menu");
	    	}
	    	if (level == 2) {
	    		list.addClass("nav-second-level");
	    	}
	    	else if (level == 3) {
	    		list.addClass("nav-third-level");
	    	}
	    	else if (level == 4) {
	    		list.addClass("nav-fourth-level");
	    	}
	    	for (var i = 0; i < items.length; ++i) {
	    		var mi = items[i];
	    		var el = that._createElement(mi, level);
	    		list.append(el);
	    	}
	    	//wrapper.append(list);
	    	return list;
	    },
        _createElement: function (mi, level) {
	    	var that = this;
	    	var el = $("<li>", { title: mi.text, class: "nav-item w-100" });
	    	mi.element = el;
	    	var opis = $("<span>", {  class: "konto-menu-opis", text: mi.opis });
	    	var link = $("<a>", { class: "nav-link", "aria-expanded": "false" }).append(opis);
	    	if (that.options.koristiIkone && mi.ikona > 0) {
	    		var path = kontorouter.getPath("assets/images/menu/" + mi.ikona + ".png");
		    	var ikona = $("<img>", { class: "konto-menu-icon", src: path });
		    	link.prepend(ikona);
	    	}
	    	else {
	    		var fakeIkona = $("<div>", { class: "konto-menu-icon" } );
	    		fakeIkona.css("display", "inline-block");
	    		link.prepend(fakeIkona);
	    	}

	    	var putanja = mi.putanja ? mi.putanja : "";
	    	mi.pathInfo = null;
	    	if (putanja) {
	    		mi.pathInfo = that._getPathInfo(mi.putanja);

	    		link.attr("href", putanja);
	    		link.click(function (event) {
	    		    event.preventDefault();
	    		    that._open(putanja, el);
	    		});
	    	}
	    	//el.append(ikona);
	    	el.append(link);
	    	if (mi.items && mi.items.length > 0) {
				link.addClass("has-arrow");
	    		var els = that._createElements(mi.items, level + 1);
	    		el.append(els);
	    	}
	    	return el;
	    },
	    /**
	     * Parametri su matche-ani u slučaju da pi1 je sadrzan u pi2.
	     * Npr.
	     * controller/action/param1
	     * se smatra matchom i u slučaju
	     * controller/action/param1/param2
	     *
	     * Ovo nije potpuna evaluacija, ali je bolja od prijašnjeg načina koji je uspoređivao samo controller
	     * i action.
	     *
	     * */
	    _paramsMatch: function (pi1, pi2) {
	    	if (pi2.params) {
	    		if (pi1.params) {
	    			for (var i = 0; i < pi2.params.length; ++i) {
	    				if (pi1.params.length <= i)
	    					break;
	    				if (pi1.params[i].toLowerCase() != pi2.params[i].toLowerCase()) {
	    					return false;
	    				}
	    			}
	    		}
	    		else
	    			return true;
	    	}
	    	return true;
	    },
	    _createElementsNavbar: function (items, level) {
	    	var that = this;
	    	if (!level)
	    		level = 1;
	    	
	    	if (level == 1){
	    	    var list = $("<ul></ul>");	    	  
				list.addClass("nav");
			}
	    	else{
	    	    var list = $("<div></div>");
	    		list.addClass("dropdown-menu");
	    	}
	    	
	    	if (level == 2) {
	    		list.addClass("navbar-second-level");
	    	}
	    	if (level == 3) {
	    		list.addClass("navbar-third-level");
	    	}
	    	for (var i = 0; i < items.length; ++i) {
	    		var mi = items[i];
	    		var el = that._createElementNavbar(mi, level, list);
	    		list.append(el);
	    	}
	    	return list;
	    },
	    _createElementNavbar: function (mi, level, parent) {
	    	var that = this;
			var el = $("<li>", {class: "nav-item" });
	    	var putanja = mi.putanja ? mi.putanja : "";
			var link = $("<a>" + mi.opis + "</a>");
			link.addClass("nav-link");
	    	if (mi.items && mi.items.length > 0) {
	    		if (level < 2) {	    		    
		    		el.addClass("dropdown");
		    		link.addClass("dropdown-toggle");
		    		link.attr("data-toggle", "dropdown");
		    		link.attr("href", "#");
		    		link.attr("role", "button");
		    		link.attr("aria-haspopup", "true");
		    		link.attr("aria-expanded", "false");
		    		
		    		//link.append(" <b class=\"caret\"></b>");
		    		el.append(link);
		    		var els = that._createElementsNavbar(mi.items, level + 1);
		    		el.append(els);
	    		}
	    		else {
	    			var naslov = $("<li class=\"dropdown-header\">" + mi.opis + "</li>");
	    			if (that.options.type == "navbar" && level >= 3)
	    				return null;
	    			parent.append(naslov);
	    			for (var i = 0; i < mi.items.length; ++i) {
	    				var subEl = that._createElementNavbar(mi.items[i], level + 1);
	    				parent.append(subEl);
	    			}
	    			var divider = $("<li class=\"divider\"></li>");
	    			parent.append(divider);
	    		}
	    	}
	    	else {
		    	if (putanja) {
		    		link.attr("href", putanja);
		    		var absPath = putanja.split('://');
		    		if (absPath.length < 2)
			    		link.click(function (event) {
			    		    event.preventDefault();
			    		    that._open(putanja, el);
			    		});
			    	else
			    		cs ('apsolutna putanja - '+putanja);

		    	}
		    	if (level > 2)
		    		el.addClass("navbar-level-" + level);
		    	if (level > 1){
		    	 el.addClass("dropdown-item");
		    	}
		    	el.append(link);
	    	}
	    	return el;
	    },
        _getPathInfo: function (link) {
	    	var base = kontorouter.defaults.modulBasePath,
	    		regex = new RegExp("[^/]*" + base + "(.*)", "i");
	    	var uri = link.replace(regex, "$1");
	    	if (uri && uri.length > 0) {
	    		var tmp = uri.split("?");
	    		var path = tmp[0];
	    		var query = tmp.length > 1 ? tmp[1] : null;

	    		var a = path.split("/");
	    		if (a.length >= 1) {
    	    		var obj = {};
    	            obj["controller"] = a[0].toLowerCase();
    	    		a = a.slice(1);

    	    		if (a.length > 0)
    	    		    obj["action"] = a[0].toLowerCase();

    	    	    a = a.slice(1);
    	    	    obj["params"] = a;
    	    	    obj["query"] = {};
					if (query !== null) {
						var kvp = query.split("&");
						for (var k = 0; k < kvp.length; ++k) {
							var x = kvp[k].split("=");
							obj["query"][x[0]] = x.length === 2 ? x[1] : null;
						}
						obj["rawQuery"] = kvp;
					}
    	    	    return obj;
	    		}
	    		else
	    			return null;
	    	}
	    	else {
	    		return null;
	    	}
	    },
	    _arePathsEqual: function (pi1, pi2) {
	        var that = this;
	        if (pi1 && pi2) {
                if (pi1.controller == pi2.controller &&
                    pi1.action == pi2.action &&
                    that._paramsMatch(pi1, pi2)) {
                    return true;
                }
            }
            return false;
	    },
	    _getPathsEquality: function (pi1, pi2) {
	        var eq = 0;
	        if (pi1 && pi2) {
    	        if (pi1.controller == pi2.controller) {
    	            ++eq;
        	        if (pi1.action == pi2.action)
        	            ++eq;
    	        }
    	        else {
    	        	return -1; /* Controlleri moraju biti isti */
    	        }

    	        if (pi1.params.length === pi2.params.length /* && !pi1.params.length == 0 */)
    	            ++eq;

    	        for (var i = 0; i < pi2.params.length; ++i) {
    	            if (pi1.params.length <= i)
    	               break;

    	            if (pi1.params[i].toLowerCase() == pi2.params[i].toLowerCase())
    	               ++eq;
    	            else
    	               --eq;

    	            var pi2SkraceniParam = pi2.params[i].toLowerCase().substring(0, pi1.params[i].length);
    	            if (pi1.params[i].toLowerCase() == pi2SkraceniParam)
    	               ++eq;
    	        }

    	        for (key in pi2.query) {
    				if (key in pi1.query) {
						if (pi1.query[key] === pi2.query[key])
							++eq;
						else
							--eq;
    				}
    	        }
	        }
	        return eq;
	    },
	    _getElementsByPutanja: function (pi, menuItems) {
	        var that = this;
	        var els = [];
            // Depth first
            $.each(menuItems, function (ind, mi) {
               if (mi.putanja) {
                   var eq = that._getPathsEquality(pi, mi.pathInfo);
                   if (eq > 0) {
                       els.push({
                           element: mi.element,
                           value: eq
                       });
                   }
               }
               if (mi.items && mi.items.length > 0) {
                   newEls = that._getElementsByPutanja(pi, mi.items);
                   Array.prototype.push.apply(els, newEls);
               }
            });
            return els;
	    },
	    _getElement: function (pi) {
	        var that = this;
	        var elements = that._getElementsByPutanja(pi, that.options.dataSource);
	        // Najpogodniji.
	        elements.sort(function (a, b) {
	            return b.value - a.value;
	        });

	        if (elements.length > 0)
	           return elements[0].element;
	        return null;
	    },
		_getSessionIndex: function(pathArray){
			var	sessionIndex = 6;
			if(Number.isInteger(Number.parseInt(pathArray[4]))){
				sessionIndex = 5;
			}
			return sessionIndex;
		},
		_getTrenutnaCookieName: function(path) {
			var pathArray = path.split('/');
			var dodatak = '';
			var sessionIndex = this._getSessionIndex(pathArray);
			if(Number.isInteger(Number.parseInt(pathArray[sessionIndex]))){
				dodatak = pathArray[sessionIndex];
			}			
			var keyName = pathArray[sessionIndex -2].toUpperCase() + pathArray[sessionIndex -1] + '_' + dodatak + '_TRENUTNA';
			return keyName;
		},
		_getTrenutnaCookieValue: function(path){
			var pathArray = path.split('/');
			var newPath = '';
			var sessionIndex = this._getSessionIndex(pathArray);
			if(Number.isInteger(Number.parseInt(pathArray[sessionIndex]))){
				for(i=sessionIndex+1; i<pathArray.length; i++){
					newPath = newPath + pathArray[i] + '/';
				}
			}
			else{
				for(i=sessionIndex; i<pathArray.length; i++){
					newPath = newPath + pathArray[i] + '/';
				}				
			}
			var link = newPath.substring(0, newPath.length -1);	
			return link;
		},
	    _open: function (path, el) {	
			document.cookie = this._getTrenutnaCookieName(path) + '=' + this._getTrenutnaCookieValue(path) + '; path={{COOKIE_ROOT}}';

	    	var that = this;
	    	var params = KUtils.getQueryFromUrl(path);
	    	if ("menu_modal" in params && params.menu_modal === "1") {

	    		var options = {};
	    			options["template"] = path;

	    		//postavljamo sirinu modalnog (ukoliko je definirana u parametrima linka)
	    		if ("width" in params)
	    			options["width"] = params.width;

	    		konto.dialogs.modal(options);
	    	}
	    	else {
	    		kontorouter.goto(path);
	    		if (that._sidebar)
	    		 	that._sidebar.removeClass("show");

	    		that.select(el);
                that.selectedElement = el;
                window.scrollTo(0, 0);
	    	}
	    },
	    select: function (el) {
	        var that = this;
	        if (that.selectedElement) {
	           that.selectedElement.removeClass("selected");
	           that.selectedElement.parentsUntil("nav", "li").each(function () {
	               var $el = $(this);
	               $el.removeClass("selected").removeClass("mm-active");
	               // Za zatvaranje i otvaranje menija s podmenijima.
	               $el.find("> ul").removeClass("show");
	           });
	        }
	        if (el !== null) {
	            el.addClass("selected");
	            if (that.options.type == "side") {
                    el.parentsUntil("nav", "li").each(function () {
                        $(this).addClass("selected mm-active");
                    });
                }
            }

            that.selectedElement = el;

            if (that._metisMenu) {
                // Ovime postižemo collapse.
                that._metisMenu.init();
            }
	    },
	    selectPutanja: function (putanja, menuItems) {
	        var that = this;
	        var pi = that._getPathInfo(putanja);
	        var selectedElement = that._getElement(pi, that.options.dataSource);
			that.select(selectedElement);
			return selectedElement;
	    }
    });

    ui.plugin(KontoMenu);

})(jQuery);